let axios = require('axios').default
// import config from './config'

axios.defaults.baseURL = process.env.VUE_APP_BACKEND_HOST

async function getPossibleSettings(token, hasPRAL8) {
  return axios.get('/possible-settings?hasPRAL8=' + hasPRAL8.toString(), {
    headers: {'authorization': token}
  })
}

async function getUserInfo(token) {
  return axios.get('/prepaid-service-info', {
    headers: {'authorization': token}
  })
}

async function subscribe(token, subscribeData) {
  return axios.post('/subscribe', subscribeData, {
    headers: {'authorization': token}
  })
}

async function setAutoRenew(token, autoRenewData) {
  return axios.post('/set-auto-renew', autoRenewData, {
    headers: {'authorization': token}
  })
}

async function subscribeWithCode(token, code) {
  return axios.post('/subscribe-code', { code }, {
    headers: {'authorization': token}
  })
}

async function getUpsellSettings(token, subscribeData) {
  return axios.post('/upsell', subscribeData , {
    headers: {'authorization': token}
  })
}

let api = {
  getUserInfo,
  subscribe,
  subscribeWithCode,
  getPossibleSettings,
  getUpsellSettings,
  setAutoRenew
}

export default api
